import { render } from "./DeliveryMethodRetailerSelector.vue?vue&type=template&id=7781f3d4"
import script from "./DeliveryMethodRetailerSelector.vue?vue&type=script&lang=js"
export * from "./DeliveryMethodRetailerSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__